const faqData = [
  {
    question: "What services does Yuvraj Mehandi Artist offer in Delhi?",
    answer:
      "Yuvraj Mehandi Artist provides a wide range of Mehndi services in Delhi, including bridal Mehndi, party Mehndi, and festive Mehndi designs. We specialize in traditional, Arabic, and contemporary Mehndi patterns to suit all occasions.",
  },
  {
    question: "How experienced is the team at Yuvraj Mehandi Artist in Delhi?",
    answer:
      "Our team at Yuvraj Mehandi Artist in Delhi consists of highly skilled and experienced Mehndi professionals with years of expertise in creating intricate and beautiful designs for weddings, festivals, and other events.",
  },
  {
    question: "Do you offer Mehndi services at home in Delhi?",
    answer:
      "Yes, we provide Mehndi services at your location in Delhi for your convenience. Whether it’s a wedding, festival, or any special event, our team will ensure you get the best Mehndi experience at the comfort of your home.",
  },
  {
    question:
      "What types of Mehndi designs does Yuvraj Mehandi Artist specialize in?",
    answer:
      "Yuvraj Mehandi Artist specializes in a variety of Mehndi designs, including bridal, Arabic, Rajasthani, Indo-Arabic, and contemporary patterns. We customize designs based on your preferences and the occasion.",
  },
  {
    question:
      "How can I book an appointment with Yuvraj Mehandi Artist in Delhi?",
    answer:
      "You can book an appointment with Yuvraj Mehandi Artist by contacting us through our website or phone. We recommend booking in advance to secure your preferred time slot, especially during the wedding and festive seasons.",
  },
  {
    question:
      "Are the Mehndi products used by Yuvraj Mehandi Artist safe for the skin?",
    answer:
      "Absolutely! At Yuvraj Mehandi Artist, we use 100% natural and skin-safe Mehndi products. Our Mehndi paste is free from harmful chemicals, ensuring a safe and beautiful stain for all our clients.",
  },
];

export default faqData;
